import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function ProtectedRoute({ children }) {
  const isResolved = useSelector((state) => state.auth.isResolved);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  // Если пользователь не авторизован, перенаправляем на главную страницу
  if (!isResolved) return null;
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  // Если авторизован, возвращаем защищённый компонент
  return children;
}

export default ProtectedRoute;
